import { render, staticRenderFns } from "./CharityPopup.vue?vue&type=template&id=507d1e4a&scoped=true&lang=pug"
import script from "./CharityPopup.vue?vue&type=script&lang=js"
export * from "./CharityPopup.vue?vue&type=script&lang=js"
import style0 from "./CharityPopup.vue?vue&type=style&index=0&id=507d1e4a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507d1e4a",
  null
  
)

export default component.exports